import { render, staticRenderFns } from "./MODEL-Delivered.vue?vue&type=template&id=6e3c71b4&"
import script from "./MODEL-Delivered.vue?vue&type=script&lang=js&"
export * from "./MODEL-Delivered.vue?vue&type=script&lang=js&"
import style0 from "./MODEL-Delivered.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports